import React, { useState } from 'react';
import { ProfilePhoto } from './profile-photo';
import IconButton from '@/ctComponents/IconButton';
import { Icons } from '@/assets';
import { ReactSVG } from 'react-svg';
import { EditInformation } from './edit-information';
import { ChangePassword } from './change-password';

const ProfileRow = ({ icon, label, value, isLast = false }) => {
  return (
    <div className={`flex justify-between ${!isLast ? 'border-b pb-2' : ''}`}>
      <span className="font-bold text-sm flex items-center">
        <ReactSVG
          src={icon}
          className="mr-2"
          beforeInjection={(svg) => {
            svg.setAttribute('width', '20');
            svg.setAttribute('height', '20');
          }}
        />
        {label}:
      </span>
      <span className="text-sm text-secondary-text">{value || 'N/A'}</span>
    </div>
  );
};

export const ProfileInformation = ({ user }) => {
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openChangePasswordModal, setOpenChangePasswordModal] = useState(false);

  return (
    <>
      <div className="flex flex-col lg:flex-row gap-16">
        <ProfilePhoto user={user} />

        <div className="border border-solid pb-4 px-4 flex-1 rounded-md">
          <div className="flex justify-between items-center">
            <h2 className="text-lg font-bold ">Profile Information</h2>

            <IconButton
              onClick={() => {
                setOpenEditModal(true);
              }}
              icon={'pen'}
              style={{ fontWeight: 400, height: 40 }}
              text={'Edit'}
              color={'#131617'}
              size={'big'}
            />
          </div>
          <hr className="mb-4 mt-0  border-t border-solid" />
          <div className="space-y-3">
            <ProfileRow
              icon={Icons.singleUser}
              label="Name"
              value={
                user?.name
                  ? `${user.name} ${user.last_name || ''}`.trim()
                  : null
              }
            />

            <ProfileRow
              icon={Icons.company}
              label="Company"
              value={user?.company}
            />

            <ProfileRow
              icon={Icons.phoneProfile}
              label="Phone"
              value={user?.phone}
            />

            <ProfileRow
              icon={Icons.mailProfile}
              label="Email"
              value={user?.email}
            />

            <ProfileRow
              icon={Icons.mapPin}
              label="Office Address"
              value={user?.address}
            />

            <ProfileRow
              icon={Icons.mapPin}
              label="Yard Address"
              value={
                user?.yard_location
                  ? `${user.yard_location}${
                      user.yard_zip ? `, ${user.yard_zip}` : ''
                    }`
                  : null
              }
            />

            <ProfileRow
              icon={Icons.clock2}
              label="Yard Hours"
              value={
                user?.yard_start && user?.yard_end
                  ? `${user.yard_start} - ${user.yard_end}`
                  : null
              }
            />

            <ProfileRow
              icon={Icons.buildingProfile}
              label="SCAC"
              value={user?.yard_scac}
            />

            <ProfileRow
              icon={Icons.buildingProfile}
              label="DOT"
              value={user?.yard_dot}
            />

            <div className="flex justify-between">
              <span className="font-bold text-sm flex items-center">
                <ReactSVG
                  src={Icons.lock}
                  className="mr-2 text-icon-gray"
                  beforeInjection={(svg) => {
                    svg.removeAttribute('style');
                    svg.removeAttribute('width');
                    svg.removeAttribute('height');
                    svg.setAttribute('width', '20');
                    svg.setAttribute('height', '20');
                    svg.querySelectorAll('path').forEach((path) => {
                      path.setAttribute('stroke', '#999999');
                    });
                  }}
                />
                Password:
              </span>
              <button
                onClick={() => setOpenChangePasswordModal(true)}
                className="p-0 border-none shadow-none font-averta bg-transparent text-primary-blue cursor-pointer font-bold text-sm">
                Change Password
              </button>
            </div>
          </div>
        </div>
      </div>
      <EditInformation
        show={openEditModal}
        setShow={setOpenEditModal}
        data={user}
      />
      <ChangePassword
        show={openChangePasswordModal}
        setShow={setOpenChangePasswordModal}
      />
    </>
  );
};
